export interface Customer {
  _id: string;
  name: string;
}

export const mapCustomerResponse = (response: any): Customer => {
  return {
    _id: response._id,
    name: response.name,
  };
};

export const mapCustomersResponse = (response: any): Customer[] => {
  if (!response.data || !Array.isArray(response.data?.customers)) {
    return [];
  }
  return response.data.customers.map(mapCustomerResponse);
};
